import lazyWithSuspense from 'modules/lazyWithSuspense';
import makePage from 'modules/makePage';
import Page from 'modules/Page';
import { i18n } from 'i18n';
import * as parentConstants from 'modules/project-admin/ProjectsPage/constants';
import { toTitleCase } from 'utils';
import * as constants from './constants';
import { ProjectDetailsPageParams } from './constants';
import useProjectDetailsQueries, { ProjectDetailsQueries } from './useProjectDetailsQueries';

const ProjectDetailsPage = lazyWithSuspense(() => import('./ProjectDetailsPage'));

const page: Page = {
  title: constants.TITLE,
  routeProps: {
    path: constants.ROUTE_PATH,
  },
  admin: true,
  component: makePage<ProjectDetailsPageParams, ProjectDetailsQueries>({
    WrappedPage: ProjectDetailsPage,
    titleFn: ([project]) => (project.data ? `${toTitleCase(project.data.name)}`.concat(i18n._('Details')) : ''),
    parentPathTemplate: parentConstants.ROUTE_PATH,
    parentTitleFn: () => i18n._(parentConstants.TITLE),
    pageDataHook: useProjectDetailsQueries,
  }),
};

export default page;
